export async function registerServiceWorker () {
    console.log('Ensuring service worker is registered...');
    const registration = await navigator.serviceWorker.register('/service-worker.js', {
        // scope SHOULD work but it doesn't
        // scope: '/file', // only intercept requests to /file
    });
    await registration.update(); // ensures the service worker is updated on first load
    console.log(`service worker registered with state: \nwaiting: ${Boolean(registration.waiting)}\ninstalling: ${Boolean(registration.installing)}\nactive: ${Boolean(registration.active)}`);
    if (!navigator.serviceWorker.controller) {
        console.warn('Service worker did not claim the client, trying to force claim...');
        const { active } = await navigator.serviceWorker.ready;
        if (!active) {
            throw new Error('Service worker is not active');
        }
        active.postMessage({ kind: 'forceClaim' });
        await new Promise<void>((resolve, reject) => {
            setTimeout(() => reject(new Error('Service worker did not claim the client')), 1000);
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (navigator.serviceWorker.controller) {
                    console.log('Service worker claimed the client');
                    resolve();
                } else {
                    console.warn('Service worker did not claim the client');
                    reject(new Error('Service worker did not claim the client'));
                }
            }, { once: true });
        });
    } else {
        console.log('Client is already claimed by service worker');
    }
}
